import React, { useRef, useState, useEffect } from "react";
import SmallLoader from "../../Common/smallLoader";
import { Modal } from "react-bootstrap";
import {
  AESEncryption,
  ApiResDecrypt,
  noDataFound,
} from "../../../CommonMethhods/CommonMethods";
import Loader from "../../Common/Loader";
import LoaderForSearch from "../../Common/LoaderForSearch";
import axios from "axios";
import { DASHBOARD_DEFAULT } from "../../../Configuration/API_URL";
import { toast } from "react-toastify";

const MTFBookSnapshot = (props) => {
  const [page, setPage] = useState(1);
  const [mtfBookList, setMtfBookList] = useState([]);
  const [mtfListLoader, setMtfListLoader] = useState(false);
  const [scrollLoader, setScrollLoader] = useState(false);
  const [totalCount, setTotalCount] = useState();

  const storeToken = props?.storeToken;

  const setButtonLoader = props?.setButtonLoader;

  useEffect(() => {
    getMTFBookDetails("grid", 1);
  }, []);

  const getMTFBookDetails = async (type, pageno) => {
    if (type === "grid" && pageno <= 1) setMtfListLoader(true);
    if (type === "pdf")
      setButtonLoader({
        pdf: true,
      });
    if (type === "excel")
      setButtonLoader({
        excel: true,
      });

    let payloadValue = {
      fileType: type,
      pagesize: type === "grid" ? 10 : -1,
      pageno,
    };

    let encPayload = AESEncryption(payloadValue);
    try {
      let response = await axios.post(
        DASHBOARD_DEFAULT.MTFBookDetails_URL,
        `"${encPayload}"`,

        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      response = ApiResDecrypt(response.data);
      if (response?.status === 0) {
        if (type === "grid") {
          setTotalCount(response.data.totalCounts);
          if (pageno > 1) {
            setMtfBookList((prev) => {
              return [...prev, ...response?.data?.mtfBookList];
            });
          } else {
            setMtfBookList(response?.data?.mtfBookList);
          }
          setScrollLoader(false);
        } else if (type === "excel")
          window.open(response?.data, "_self", "noopener,noreferrer");
        else if (type === "pdf")
          window.open(response?.data, "_blank", "noopener,noreferrer");
      } else {
        setMtfBookList([]);
        if (type !== "grid") toast.error(response?.message);
      }
    } catch (error) {
      console.error("Error fetching MTF Details:", error);
    } finally {
      setMtfListLoader(false);
      setButtonLoader({
        pdf: false,
        excel: false,
      });
    }
  };

  const handleTableScroll = (e) => {
    const el = e.target;
    const scrolledToBottom =
      el.scrollTop + el.offsetHeight + 1 >= el.scrollHeight;

    if (scrolledToBottom && !scrollLoader) {
      const nextPage = page + 1;
      const totalLoadedRecords = page * 10;

      if (
        totalCount > totalLoadedRecords &&
        totalCount !== mtfBookList.length
      ) {
        setPage(nextPage);
        setScrollLoader(true);
        setMtfListLoader(false);
        getMTFBookDetails("grid", nextPage);
      } else {
        setScrollLoader(false);
      }
    }
  };

  return (
    <>
      <div
        className="table-responsive  model-top-active-table"
        style={{ width: "99%" }}
      >
        {mtfListLoader ? (
          <div className="loader-alignment">
            <Loader />
          </div>
        ) : mtfBookList && mtfBookList.length > 0 ? (
          <table className="table">
            <thead>
              <tr>
                <th className="text-center">Client ID</th>
                <th className="text-center">Total MTF Book</th>
              </tr>
            </thead>

            <tbody id="mtfBook" onScroll={(e) => handleTableScroll(e)}>
              {mtfBookList.map((item) => (
                <tr key={item.partyCode}>
                  <td className="text-center text-primary">{item.partyCode}</td>
                  <td className="text-center">{item.totalMtfBook}</td>
                </tr>
              ))}
              {scrollLoader && !mtfListLoader && (
                <div className="loader-center">
                  <LoaderForSearch />
                </div>
              )}
            </tbody>
          </table>
        ) : (
          noDataFound()
        )}
      </div>

      <div className="generate-btn-wrapper">
        <button
          className="generate-btn text-green"
          value="excel"
          onClick={() => getMTFBookDetails("excel", -1)}
        >
          {props?.buttonLoader?.excel ? (
            <SmallLoader />
          ) : (
            <>
              <span className="icon-excelsvg"></span>
              {"Excel"}
            </>
          )}
        </button>
        <button
          className="generate-btn txt-purple"
          value="pdf"
          onClick={() => getMTFBookDetails("pdf", -1)}
        >
          {props?.buttonLoader?.pdf ? (
            <SmallLoader />
          ) : (
            <>
              <span className="icon-pdfsvg"></span> {"PDF"}
            </>
          )}
        </button>
      </div>
    </>
  );
};

export default MTFBookSnapshot;
